import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";

interface DeletedImagePlaceholderProps {
  positionClassName?: string;
}

export const DeletedImagePlaceholder = ({
  positionClassName,
}: DeletedImagePlaceholderProps) => (
  <div
    className={classNames(
      "bg-secondary relative flex shrink-0 grow-0 basis-full items-center justify-center",
      positionClassName,
    )}
  >
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <div className="mb-4">
        <Icon type="16-trash-bin-2" size={20} />
      </div>
      <Typography.BodySm color="light">
        {t("image_space.file_not_found")}
      </Typography.BodySm>
    </div>
  </div>
);
